import classnames from 'classnames'

import Button from '@components/Button'
import Modal from '@components/Modal'

import { payInvoice } from 'dashboard-subscriptions/actions'
import { invoicePaymentPendingSelector, paymentMethodSelector } from 'dashboard-subscriptions/selectors'

import useRequestPending from 'shared/hooks/useRequestPending'

import styles from './styles.module.scss'

const PaymentModal = ({ paymentMethod, invoice, subscriptionId, closeModal, payInvoice, pending }) => {
    const { nameOnCard, lastFour, id: paymentMethodId } = paymentMethod
    const { error } = useRequestPending(pending, () => closeModal())

    const submit = () => {
        payInvoice({
            amount: invoice.balance,
            invoiceId: invoice.id,
            subscriptionId,
        })
    }

    return (
        <Modal className={styles.paymentModal} size="small" onClose={closeModal}>
            <div className="text-left">
                <span className={styles.liftedText}>
                    <T>dashboard.subscriptions.invoices.invoice</T>: #{invoice.invoiceNumber}
                </span>
                {error && <span className={classnames('mt-3', 'd-block', styles.error)}>{error}</span>}
                {!paymentMethodId && (
                    <span className={classnames('mt-3', 'd-block', styles.error)}>
                        <T>dashboard.subscriptions.invoices.payment.method.error</T>
                    </span>
                )}
            </div>
            <div>
                <div className="d-flex justify-content-between mt-3">
                    <span>
                        <T>dashboard.subscriptions.invoices.payment.method</T>
                    </span>
                    {paymentMethodId && (
                        <span>
                            {nameOnCard} **** {lastFour}
                        </span>
                    )}
                </div>
                <div className="d-flex justify-content-between mt-3">
                    <span>
                        <T>dashboard.subscriptions.invoices.total</T>
                    </span>
                    <span className={styles.liftedText}>${invoice.balance}</span>
                </div>
            </div>
            <div className="d-flex justify-content-between mt-4">
                <Button className="col-6" btnStyle="outline" onClick={closeModal}>
                    <T>dashboard.subscriptions.modal.close</T>
                </Button>
                <Button
                    className="col-6"
                    btnStyle="primary"
                    onClick={submit}
                    isLoading={pending && !error}
                    disabled={!paymentMethodId}>
                    <T>dashboard.subscriptions.confirm</T>
                </Button>
            </div>
        </Modal>
    )
}

const mapStateToProps = (_, ownProps) =>
    createStructuredSelector({
        paymentMethod: paymentMethodSelector(ownProps.subscriptionId),
        pending: invoicePaymentPendingSelector,
    })

export default compose(connect(mapStateToProps, { payInvoice }))(PaymentModal)
